import ModelService from "./abstract/ModelService";
import User from "../models/User";

export default class UserService extends ModelService {
  constructor() {
    super('/users', User);
  }

  updatePreference(model) {
    return new Promise((resolve, reject) => {
      this.put(env.API_URL + this.modelPath + '/' + model.user_id + '/preference', this.modelName ? { [this.modelName]: model } : model).then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  setInactive(model_id) {
    return new Promise((resolve, reject) => {
      this.put(env.API_URL + this.modelPath + '/' + model_id + '/set-inactive').then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  fetchUser() {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath + '/find-by-token').then((data) => {
        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  /** Deliberately not this.post(), for the reason given on resetPassword(). */
  forgotPassword(model) {
    return new Promise((resolve, reject) => {
      axios.post(env.API_URL + '/password/email', { login: model.login })
        .then(response => resolve(response.data))
        .catch(e => reject(e.response));
    });
  }

  /**
   * Deliberately not this.post(): the shared failure handler answers a 422 with a
   * generic "Please check the form for errors" dialog, in English, which would talk
   * over the per-field reasons the reset screen now renders itself. Other forms still
   * rely on that dialog, so it stays where it is.
   */
  resetPassword(model) {
    return new Promise((resolve, reject) => {
      axios.post(env.API_URL + '/password/reset', model)
        .then(response => resolve(response.data))
        .catch(e => reject(e.response));
    });
  }
}
